import type { IPartnerDocumentSection } from '../../../lib/documentsAndLinks'
import type { TDocumentType } from '../types'

export const countDocuments = (sections: IPartnerDocumentSection[], type?: TDocumentType | null) =>
  sections.reduce(
    (count, section) =>
      count +
      (type === 'qbr' ? 0 : section.eltDocuments.length) +
      (type === 'elt' ? 0 : section.qbrDocuments.length),
    0
  )
